/**
 * Semantic typography roles — single source for text size / weight / color.
 * Regular iPad = baseline; bp-2xl = Pro / large screen bump where noted.
 * Shells compose: layout classes + typeShell.role (no raw text-* in Shells).
 */

export const typeShell = {
    /* —— Headings —— */
    pageTitle:
        "text-xl font-semibold leading-none text-text-primary bp-lg:text-2xl bp-2xl:text-3xl",
    sectionTitle:
        "text-lg font-semibold leading-snug text-text-primary bp-lg:text-xl bp-2xl:text-2xl",
    formSubsectionTitle:
        "text-base font-semibold leading-normal text-text-primary bp-lg:text-lg",
    panelTitle:
        "text-xl font-bold leading-tight text-text-secondary max-[440px]:text-sm",

    /* —— Body —— */
    body: "text-sm leading-normal text-text-primary bp-2xl:text-base",
    bodyMedium: "text-sm font-medium leading-normal text-text-primary bp-2xl:text-base",
    bodySemibold: "text-sm font-semibold leading-normal text-text-primary bp-2xl:text-base",
    muted: "text-sm leading-normal text-text-muted bp-2xl:text-base",
    hint: "text-xs leading-normal text-text-hint bp-2xl:text-sm",
    error: "text-xs font-medium leading-normal text-error bp-2xl:text-sm",

    /* —— Account / stat display —— */
    statLabel:
        "text-xs leading-normal tracking-wide text-text-muted bp-2xl:text-sm",
    statValue:
        "text-sm font-semibold leading-normal text-text-primary bp-2xl:text-base",
    statusMessage:
        "text-sm font-medium leading-normal text-text-primary bp-2xl:text-lg",

    /* —— Form / meta —— */
    fieldLabel:
        "text-xs font-semibold leading-normal text-text-primary bp-2xl:text-sm",
    metaLabel:
        "text-xs font-semibold leading-tight text-text-secondary bp-2xl:text-sm",
    metaValue:
        "text-xs font-medium leading-tight text-text-primary bp-2xl:text-sm",

    /* —— Supporting / dense UI —— */
    empty: "text-2xs leading-normal text-text-hint bp-2xl:text-sm",
    emptyPanel: "text-xs leading-normal text-text-hint bp-2xl:text-base",
    actionPrompt:
        "text-xs font-medium leading-snug text-text-primary bp-2xl:text-base bp-2xl:font-normal bp-2xl:leading-normal",
    caption: "text-xs leading-normal text-text-primary bp-2xl:text-sm",
    captionMuted: "text-xs leading-normal text-text-muted bp-2xl:text-sm",
    captionSemibold:
        "text-xs font-semibold leading-normal text-text-primary bp-2xl:text-sm",
    chromeLabel:
        "text-xs font-semibold uppercase tracking-wide text-text-primary bp-lg:text-xs bp-2xl:text-sm",
    navLabel:
        "text-xs font-bold leading-none bp-2xl:text-sm",
    badge: "text-xs font-semibold tabular-nums",
    tabLabel:
        "text-sm font-semibold leading-tight max-[440px]:text-xs",
};

/** Form field text + compact control height on iPad */
export const fieldText =
    "text-sm leading-normal text-text-primary bp-2xl:text-base bp-2xl:leading-normal";

/**
 * Fixed-height input/select text: leading-none so glyphs fit in controlHeight.
 * Do not use fieldText here — its leading-normal clips inside h-11 + border-2.
 */
export const fieldTextControl =
    "text-sm leading-none text-text-primary bp-2xl:text-base bp-2xl:leading-none";

export const fieldTextMuted =
    "text-sm leading-normal text-text-muted bp-2xl:text-base bp-2xl:leading-normal";

export const controlHeight =
    "h-11 min-h-11 max-h-11";
